export const it = {
    common: {
        PIN_CODE_LABEL: 'Codice PIN',
        USER_NAME_LABEL: 'Nome e cognome',
        comment: 'Commento',
        year: 'Anno',
        configuration: 'Configurazione',
        cancel: 'Annulla',
        search: 'Cerca',
        remove: 'Rimuovi',
        confirmationDialogTitle: 'Sei sicuro di rimuovere questo elemento?',
        selectDate: 'Seleziona data',
        select: 'Seleziona',
        notFound: 'Non trovato',
        equipmentPickerPlaceholder: 'Oggetto attrezzatura...',
        searchPlaceholder: 'Cerca...',
        equipmentTypePickerPlaceholder: 'Tipo di attrezzatura...',
        equipmentTypePickerTitle: 'Seleziona tipo di attrezzatura',
        emptyTableMessage: 'Nessun dato',
        flowPikcerTitle: 'Seleziona flusso',
        selectIcon: 'Seleziona icona',
        locationPickerTitle: 'Seleziona posizione',
        locationPlaceholder: 'Posizione...',
        noSublocations: 'Nessuna sottoposizione',
        locationsTitle: 'Posizioni',
        edit: 'Modifica',
        save: 'Salva',
        added: 'Aggiunto',
        updated: 'Aggiornato',
        add: 'Aggiungi',
        removed: 'Rimosso',
        reload: 'Ricarica',
        confirm: 'Conferma',
        rollBack: 'Annulla',
        images: 'Immagini',
        documents: 'Documenti',
        download: 'Scarica',
        saved: 'Salvato',
        date: 'Data',
        hour: 'Ora',
        preview: 'Anteprima',
        data: 'Dati',
        attributes: 'Attributi',
        checkList: 'Checklist',
        name: 'Nome',
        type: 'Tipo',
        status: 'Stato',
        designation: 'Designazione',
        symbol: 'Simbolo',
        serialNumber: 'Numero di serie',
        registryNumber: 'Numero di registro',
        machineNumber: 'Numero di macchina',
        udtNumber: 'Numero UDT',
        manufacturedYear: 'Anno di produzione',
        manufacturer: 'Produttore',
        supplier: 'Fornitore',
        mainSupplier: 'Fornitore principale',
        attribute: 'Attributo',
        nameRequired: 'Nome richiesto',
        yearGreaterThan: "L'anno deve essere maggiore di",
        location: 'Posizione',
        fieldRequired: 'Questo campo è richiesto',
        description: 'Descrizione',
        minimumQuantity: 'Quantità minima',
        optimalQuantity: 'Quantità ottimale',
        priority: 'Priorità',
        formatYYYY: 'Formato YYYY',
        storageQuantity: 'Quantità in magazzino',
        quantity: 'Quantità',
        quantityGreaterThan: 'La quantità deve essere maggiore di',
        machine: 'Macchina',
        tool: 'Strumento',
        order: 'Ordine',
        required: 'Richiesto',
        dateFormat: 'Formato data',
        selectDictionary: 'Seleziona dizionario',
        selectDictionaryValue: 'Selezionare il valore del dizionario',
        return: 'Ritorna',
        parameters: 'Parametri',
        editCategory: 'Modifica categoria',
        addCategory: 'Aggiungi nuova categoria',
        changeColor: 'Cambia colore',
        noColor: 'Nessun colore',
        shift: 'Turno',
        start: 'Inizio',
        end: 'Fine',
        shiftSchema: 'Schema turni',
        shifts: 'Turni',
        dictionary: 'Dizionario',
        subEntries: 'Voci secondarie',
        key: 'Chiave',
        value: 'Valore',
        moveUp: 'Sposta in su',
        moveDown: 'Sposta in giù',
        addLocation: 'Aggiungi nuova posizione',
        editLocation: 'Modifica posizione',
        companiesDatabase: 'Database delle aziende',
        flows: 'Flussi',
        read: 'Leggi',
        write: 'Scrivi',
        noImage: 'Nessuna immagine',
        email: 'E-mail',
        function: 'Funzione',
        active: 'Attivo',
        notActive: 'Non attivato',
        disabled: 'Disabilitato',
        entryNumber: 'Numero di entrata',
        issuedDate: 'Data di emissione',
        expiresDate: 'Data di scadenza',
        move: 'Spostare',
        separateForm: 'Separare da',
        separate: 'Separare',
        warehouse: 'Magazzino',
        actions: 'Azioni',
        putInCurrentLocation: 'Mettere nella posizione corrente',
        selectLocationFormRightMenu: 'Seleziona la posizione dal menu a destra',
        showUnassignedItems: 'Mostra elementi non assegnati',
        separated: 'Separato',
        moved: 'Spostato',
        categories: 'Categorie',
        welcome: 'Benvenuto',
        loginToSignaloCMMS: 'Accedi a Signalo CMMS',
        login: 'Accedi',
        loginByEmailAndPassword: 'Accedi con e-mail e password',
        loginByCode: 'Accedi con codice',
        accessCode: 'Codice di accesso',
        enterEmail: 'Inserisci email',
        enterPassword: 'Inserisci password',
        enterCode: 'Inserisci codice',
        userNotFound: 'Utente non trovato',
        userNotActivated: 'Utente non attivato',
        userDisabled: 'Utente disabilitato',
        wrongPassword: 'Password sbagliata',
        locations: 'Posizioni',
        pageNotFound: 'Pagina non trovata',
        group: 'Gruppo',
        yes: 'Sì',
        no: 'No',
        hourlyCost: 'Costo orario',
        price: 'Prezzo',
        newEntry: 'Nuova voce',
        predictedFinishTime: 'Tempo previsto di completamento',
        ok: 'Ok',
        archive: 'Archivio',
        costs: 'Costi',
        companyManagement: 'Gestione azienda',
        companyData: 'Dati aziendali',
        supportedLanguages: 'Lingue supportate',
        en: 'Inglese',
        pl: 'Polacco',
        es: 'Spagnolo',
        de: 'Tedesco',
        it: 'Italiano',
        fr: 'Francese',
        ru: 'Russo',
        uk: 'Ucraino',
        pt: 'Portoghese',
        tr: 'Turco',
        nl: 'Olandese',
        sr: 'Serbo',
        defaultLanguage: 'Lingua predefinita',
        companyLogo: "Logo dell'azienda",
        notificationsManagement: 'Gestione delle notifiche',
        category: 'Categoria',
        today: 'Oggi',
        month: 'Mese',
        week: 'Settimana',
        day: 'Giorno',
        close: 'Chiudi',
        show: 'Mostra',
        rollBackFormalConfirmation: 'Conferma formale del ripristino',
        signUp: 'Iscriviti',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Etichetta nome e cognome',
        userNameSurname: 'Nome e cognome',
        userSurnameName: 'Cognome e nome',
        phone: 'Numero di telefono',
        password: 'Password',
        password_confirmation: 'Conferma password',
        unassignedItems: 'Elementi non assegnati',
        currency: 'Valuta',
        general: 'Generale',
        timezone: 'Fuso orario',
        users: 'Utenti',
        groups: 'Gruppi',
        productionLine: 'Linea di produzione',
        part: 'Parte',
        fittingParts: 'Parti adattabili',
        workSchema: 'Schema di lavoro',
        workSchemas: 'Schemari di lavoro',

        holiday: 'Vacanza',
        changePassword: 'Cambia password',
        showRest: 'Mostra il resto',
        pageNotPermitted: 'Pagina non consentita',
        waitingForActivation: 'In attesa di attivazione',
        editGroup: 'Modifica gruppo',
        addGroup: 'Aggiungi gruppo',
        reportProblem: 'Segnala un problema',
        describeOccuredIssue: "Descrivi l'errore che si è verificato",
        markAllAsRead: 'Segna tutti come letti',
        unitType: 'Tipo di unità',
        unit: 'Unità',
        unitPrice: 'Prezzo unitario',
        notConfigured: 'Non configurato',
        rowsPerPage: 'Righe per pagina',
        rowsOfPage: 'di',
        true: 'Vero',
        false: 'Falso',
        export: 'Esporta',
        chooseFileFormat: 'Scegli il formato di file',
        exported: 'Esportato',
        terminals: 'Terminali',
        terminal: 'Terminale',
        selectEquipment: 'Seleziona attrezzatura',
        futureIssues: 'Problemi futuri',
        scheduledOn: 'Programmato il',
        planned: 'Programmato',
        notPlanned: 'Non programmato',
        showOpenIssues: 'Mostra i problemi aperti',
        pin: 'PIN',
        assignedEquipment: 'Attrezzatura assegnata',
        terminalEquipment: 'Attrezzatura terminale',
        detach: 'Stacca',
        attach: 'Allega',
        dashboardConfig: 'Configurazione dashboard',
        addColumn: 'Aggiungi colonna',
        addRow: 'Aggiungi riga',
        removeRow: 'Rimuovi riga',
        registerTerminal: 'Registra terminale',
        issueGeneratesCost: 'Tempo di fermo genera costo',
        selectColor: 'Seleziona colore',
        belowMinimum: 'Sotto minimo',
        belowOptimum: 'Sotto ottimale',
        synchronization: 'Sincronizzazione',
        synchronizationExport: 'Esportazione parti in stock',
        synchronizationImport: 'Importazione parti in stock',
        mapping: 'Mappatura',
        returnTo: 'Torna a',
        jobStatusses: 'Processi',
        hidden: 'Nascosto',
        editEvent: 'Modifica evento',
        threeDays: '3 giorni',
        addEvent: 'Aggiungi evento',
        plannedIssues: 'Problemi pianificati',
        currentService: 'Servizio corrente',
        searchLocation: 'Cerca posizione',
        all: 'Tutti',
        unfinished: 'Incompleto',
        numberOfIssues: 'Quantità problemi',
        unknown: 'Sconosciuto',
        partEntry: 'Parte (ingresso)',
        foundItems: 'Elementi trovati',
        output: 'Uscita',
        copied: 'Copiato',
        link: 'Collegamento',
        authorizationRequired: 'Autorizzazione richiesta',
        authorizationRequiredDescriptionUser:
            "Sfortunatamente, non hai autorizzazione sufficiente {value}. Chiedi a una persona autorizzata di approvare l'azione.",
        authorizationRequiredDescriptionTerminal:
            "Usa il tuo codice di accesso per autorizzare l'azione.",
        showAll: 'Mostra tutti',
        showClassicView: 'Vista classica',
        noIssuesInCategory: 'Nessun problema in questa categoria.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Numero di problemi in questa categoria e sottocategorie.',
        numberOfIssuesInThisCategory: 'Numero di problemi in questa categoria.',
        minBarcodeLength: 'Lunghezza minima del codice a barre',
        currentPage: 'Pagina corrente',
        allPages: 'Tutte le pagine',
        selectFormat: 'Seleziona formato',
        provided_currency: 'Valuta fornita',
        provided_quantity: 'Quantità fornita',
        provided_unit: 'Unità fornita',
        provided_unit_price: 'Prezzo unitario fornito',
        unit_price: 'Prezzo unitario',
        quantity_available: 'Quantità disponibile',
        editBarcode: 'Modifica codice a barre',
        crews: 'Squadre',
        scheduleEventTypes: 'Tipi di eventi pianificati',
        crew: 'Squadra',
        scheduleEvent: 'Evento di pianificazione',
        available: 'Disponibile',
        'App\\Models\\Crew': 'Squadra',
        'App\\Models\\User': 'Utente',
        'App\\Models\\Equipment': 'Attrezzatura',
        'App\\Models\\Part': 'Parte',
        Crew: 'Squadra',
        User: 'Utente',
        Equipment: 'Attrezzatura',
        Part: 'Parte',
        scheduleEvents: 'Eventi pianificati',
        event: 'Evento',
        externalSystems: 'Sistemi esterni',
        user: 'Utente',
        availability: 'Disponibilità',
        inheritColorFromParentIfCustomNotSet:
            'Eredita il colore dal padre se non impostato personalmente',
        pickFromAllParts: 'Scegli da tutte le parti',
        takeTool: 'Prendi attrezzo',
        returnTool: 'Restituisci attrezzo',
        personWhoTake: 'Persona che prende',
        personWhoReturn: 'Persona che restituisce',
        takenAt: 'Preso a',
        takenBy: 'Preso da',
        toolIssuedBy: 'Attrezzo rilasciato da',
        commentTake: 'Commento preso',
        commentReturn: 'Commento restituito',
        change: 'Cambia',
        onlyWithActiveRMIssues: 'Solo con richieste RM attive',
        externalSystem: 'Sistema esterno',
        rejectIssue: 'Rifiuta problema',
        withdrawIssueRejection: 'Ritira il rifiuto del problema',
        rejectionReason: 'Motivo del rifiuto',
        rejected: 'Rifiutato',
        showCrewMembers: 'Mostra membri della squadra',
        crewMembers: 'Membri della squadra',
        helpGroup: 'Servizio',
        partsTakenByUser: "Parti prese dall'utente",
        pickParts: 'Preleva parti',
        selectPersonWhoTakes: 'Seleziona persona che prende',
        changePersonWhoTakes: 'Cambia persona che prende',
        quantityToPick: 'Quantità da prelevare',
        pickLocation: 'Posizione di ritiro',
        selectPartsToPick: 'Seleziona le parti da prelevare',
        partSelected: 'Parte selezionata',
        scanCodeOr: 'Scansiona codice o',
        returnPart: 'Restituisci parte',
        myTakenParts: 'Parti presi da me',
        takenFromLocation: 'Preso dalla posizione',
        takenQuantity: 'Quantità presa',
        providedUnit: 'Unità fornita',
        providedQuantity: 'Quantità fornita',
        selectFromStorage: 'Seleziona dallo storage',
        selectFromMyPickedParts: 'Seleziona dalle parti raccolte da me',
        exportProcessInProgressMessage:
            'Il processo di esportazione dei dati è appena iniziato, quando sarà completato vedrai una notifica corrispondente che contiene un link al file.',
        yourDocumentIsReady: 'Il tuo documento è pronto',
        rotateScreen: 'Ruota schermo',
        addRule: 'Aggiungi regola',
        editRule: 'Modifica regola',
        summary: 'Sintesi',
        onlyAvailableEmployees: 'Mostra solo i dipendenti disponibili',
        calculated_unit_price: 'Prezzo unitario convertito',
        calculated_quantity: 'Quantità convertita',
        next: 'Prossimo',
        maintenanceMode: 'Modalità di manutenzione',
        applicationMayBeUnavailableForFewMinutes:
            "L'applicazione potrebbe non essere disponibile per alcuni minuti",
        appWillRefreshIn: "L'applicazione si aggiornerà in",
        landscape: 'Paesaggio',
        portrait: 'Ritratto',
        orientation: 'Orientamento',
        format: 'Formato',
        service: 'Servitori',
        leader: 'Capisquadra',
        defaultView: 'Vista predefinita',
        view: 'Vista',
        oneDay: '1 giorno',
        object: 'Oggetto',
        finished: 'Finito',
        onlyNotFinished: 'Solo non finito',
        generate: 'Creare',
        error: 'Errore',
        cell: 'Cella',
        resolutionSummary: 'Fine Riepilogo',
        rejected_at: 'Data di rifiuto',
        rejected_by: 'Rifiutato da',
        finishedByUser: 'Completato da',
        formalConfirmByUser: 'Conferma formale di',
        formalConfirmAt: 'Data di conferma formale',
        valueDeleted: '[Valore eliminato]',
        hasNotPlannedIssue: 'Non ha problemi pianificati',
        showInStorage: 'Mostra in deposito',
        changeCode: 'Cambia il codice',
        staffProfiles: 'Profili dei dipendenti',
        profile: 'Profilo',
        user_bug: "Errore dell'applicazione",
        user_kaizen: 'Suggerimento di cambiamento',
        changeSuggestions: 'Suggerimenti di modifica',
        showOnlyCurrentlyAvailable: 'Mostra solo attualmente disponibile',
        resetPassword: 'Ricorda password',
        forgotPassword: 'Ha dimenticato la password',
        resetPasswordMailSent:
            "Abbiamo inviato un link per impostare una nuova password all'indirizzo e-mail fornito",
        manyEventsThisTime: 'Molti eventi in questo momento',
        importScheduleCheckboxLabel:
            'Elimina gli eventi pianificati nel mese selezionato per i dipendenti elencati nel file',
        inheritedEvent: 'Evento ereditato',
        inheritedModifiedEvent: 'Evento ereditato modificato',
        equipmentId: 'ID attrezzatura',
        entryId: 'ID di ingresso',
        partId: 'ID parte',
        suggestionsEmail:
            'Email a cui verranno inviati i suggerimenti di modifica',
        meters: 'Contatori',
        scanCardToAuth:
            'Avvicina la carta al lettore o inserisci il tuo codice di accesso per confermare la tua identità.',
        scanCard: 'Scansiona la cart',
        cart: 'Scatola di scambio',
        emptyCardMessage:
            "Avvia la scansione dei prodotti o selezionali dall'elenco per aggiungerli al carrello.",
        terminalMode: 'tipo terminale',
        askPermittedUserToConfirmPartsExchange:
            'Chiedi alla persona autorizzata di confermare il rilascio della parte scansionando la carta o inserendo il codice.',
        partsIssued: 'Parti rilasciate',
        areYouSureAboutCancel: 'Sei sicuro di voler annullare?',
        areYouSureAboutRemoveFromCart:
            'Sei sicuro di voler rimuovere questo elemento dal carrello?',
        standard: 'Standard',
        idNumber: 'Numero di identificazione',
        takeParts: 'Prendi parti',
        returnParts: 'Restituisci parti',
        quantityToReturn: 'Quantità da restituire',
        partsPendingApproval: 'Parti in attesa di approvazione',
        partsReturned: 'Parti restituite',
        partsAddedToPendingApproval: 'Parti aggiunte a attesa di approvazione',
        approvePartsReturn: 'Approva il ritorno delle parti',
        partReturnApproved: 'Ritorno della parte approvato',
        partUsage: 'Uso della parte',
        awaitsReturn: 'Aspetta il ritorno',
        entrySelection: 'Selezione di ingresso',
        correctQuantity: 'Quantità corretta',
        quantityCorrection: 'Correzione della quantità',
        entrySelectionAsc: 'Selezione di ingresso (asc)',
        entrySelectionDesc: 'Selezione di ingresso (desc)',
        metersSettings: 'Impostazioni dei contatori',
        countableFields: 'Campi conteggiabili',
        equipmentTypes: 'Tipi di attrezzatura',
        fieldName: 'Nome del campo',
        countableField: 'Campo conteggiabile',
        partsStatusTaken: 'Parti prese',
        rejectPartsReturn: 'Rifiuta il ritorno delle parti',
        areYouSureAboutRejectPartsReturn:
            'Sei sicuro di voler rifiutare il ritorno delle parti?',
        partReturnRejected: 'Ritorno della parte rifiutato',
        counterFields: 'Campi contatore',
        counterName: 'Nome del contatore',
        counterFieldName: 'Nome del campo contatore',
        counterId: 'ID contatore',
        counterUUID: 'UUID contatore',
        counterPickerPlaceholder: 'Seleziona contatore',
        pickFromPartsList: 'Seleziona dalla lista delle parti',
        changeLocation: 'Cambia posizione',
        isPartStorageRoot: 'Radice del deposito delle parti',
        isStorageRoot: 'Radice del deposito delle parti',
        areYouSureAboutArchiveIssue:
            'Sei sicuro di voler archiviare questo problema?',
        ganttChart: 'Diagramma di Gantt',
        table: 'Tabella',
        fittingEquipment: 'Attrezzatura di adattamento',
        notAssigned: 'Non assegnato',
        counters: 'Contatori',
        machineHourlyCostNotProvided:
            'Il costo orario della macchina non è stato fornito',
        eventTypesMightBeDefinedHere:
            'I tipi di evento potrebbero essere definiti qui',
        toolsTakenByUser: "Strumenti presi dall'utente",
        predictedReturnDate: 'Data di ritorno prevista',
        estimatedTimeOfUsingToolInHours:
            'Tempo stimato di utilizzo dello strumento (in ore)',
        showOnlyAvailable: 'Mostra solo disponibile',
        toolTakeLog: 'Registro di utilizzo dello strumento',
        takeDate: 'Data di presa',
        returnDate: 'Data di ritorno',
        personWhoAcceptReturn: 'Persona che accetta il ritorno',
        statisticStrategy: "Strategia per l'accessibilità",
        EquipmentPlannedStrategy: 'Secondo il piano di lavoro',
        EquipmentConstantAvailabilityStrategy: 'Sempre disponibile',
        actionAfterIssueFinish: 'Azione dopo il completamento del problema',
        enabled: 'Abilitato',
        categoryOfNewIssue: 'Categoria del nuovo problema',
        workNotStarted: 'Lavoro non iniziato',
        colorInherited: 'Colore ereditato',
        abcClassification: 'Classificazione ABC',
        xyzClassification: 'Classificazione XYZ',
        classification: 'Classificazione',
        filters: 'Filtri',
        wipeFilters: 'Cancella filtri',
        takePartsFromUser: "Prendi parti dall'utente",
        selectPersonWhoReturns: 'Seleziona la persona che restituisce le parti',
        changePersonWhoReturns: 'Cambia la persona che restituisce le parti',
        returnLocation: 'Posizione di ritorno',
        returnQuantity: 'Quantità di ritorno',
        globalSettings: 'Impostazioni globali',
        delimiter: 'Delimitatore',
        fieldRules: 'Regole del campo',
        fieldValue: 'Valore del campo',
        user_email_regex: 'Regex e-mail',
        barcodeLength: 'Lunghezza del codice a barre',
        partLine: 'Linea di parti',
        partFamily: 'Famiglia di parti',
        partBatch: 'Parte del lotto (batch)',
        testValueValid: 'Valore di prova valido',
        testValueNotValid: 'Valore di prova non valido',
        canBePicked: 'Può essere scelto',
        issue_criticality: 'Problemi - criticità',
        issue_help_webapp: 'Problemi - supporto necessario (App)',
        issue_help_terminal: 'Problemi - supporto necessario (terminale)',
        issue_kind: 'Tipo di segnalazione',
        HIDE: 'Nascondere',
        SHOW: 'Spettacolo',
        REQUIRE: 'Richiedere',
        propagateValues: 'Propagazione del valore',
        archived: 'Archiviato',
        singleEvent: 'Entrata singola',
        seriesOfEvents: 'Una serie di voci',
        omitWeekends: 'Evita i fine settimana',
        allEntriesSaved: 'Tutte le voci sono state aggiunte',
        parentCategory: 'Categoria genitore',
        first_day_of_week: 'Primo giorno della settimana',
        assignEmployee: 'Assegnare un dipendente',
        addNewMachine: 'Aggiungi una nuova macchina',
        addNewTool: 'Aggiungi un nuovo strumento',
        parentLocation: 'Posizione del genitore',
        equipmentStates: "Stati dell'attrezzatura",
        equipmentState: "Stato dell'attrezzatura",
        fontColor: 'colore del carattere',
        downtime: 'Tempi di inattività',
        setState: 'Imposta lo stato',
        from: 'da',
        to: 'A',
        inProgress: 'in corso',
        noEntries: 'nessuna voce',
        products: 'Prodotti',
        product: 'Prodotto',
        setCurrentProduct: 'Imposta il prodotto attualmente in produzione',
        commentable: 'Possibilità di commentare',
        allows_state_update: 'Cambio di stato richiesto durante il commento',
        undescribed: 'Indescrivibile',
        state: 'Condizione',
        productionMonitor: 'Monitore della produzione',
        undescribedStates: 'Stati non descritti',
        toolsPicker: 'Prendere / restituire gli strumenti',
        toolsGroups: 'Gruppi di strumenti',
        of: 'di',
        image: 'Foto',
        selectTools: 'Scegli gli strumenti',
        takeTools: 'Scarica strumenti',
        returnTools: 'Restituire gli strumenti',
        askPermittedUserToConfirmToolsExchange:
            "Chiedere alla persona autorizzata di confermare l'emissione/restituzione degli strumenti scansionando la tessera o inserendo il codice.",
        toolsPendingApproval: 'Strumenti restituiti in attesa di approvazione',
        production_monitor_visible_columns:
            'Monitor di produzione: colonne visibili',
        details: 'Dettagli',
        otherData: 'Altri dati',
        showAllTools: 'Mostra tutti gli strumenti',
        allTools: 'Tutti gli strumenti',
        approveToolReturn: 'Accettare la restituzione dello strumento',
        rejectToolReturn: 'Rifiutare la restituzione dello strumento',
        areYouSureAboutRejectToolReturn:
            'Sei sicuro di voler rifiutare la restituzione dello strumento?',
        areYouSureAboutAcceptToolReturn:
            'Sei sicuro di voler confermare la restituzione dello strumento?',
        toolReturnApproved: 'Restituzione dello strumento approvata',
        toolReturnRejected: "Restituzione dell'utensile rifiutata",
        toReturn: 'Ritornare',
        toolsCart: 'Scatola di scambio - strumenti',
        toolsIssued: 'Strumenti scaricati',
        toolsAddedToPendingApproval:
            "Gli strumenti sono stati aggiunti alla lista d'attesa per l'approvazione del reso",
        toolsReturned: 'Strumenti restituiti',
        mainShift: 'Turno principale',
        scanCode: 'Scansiona il codice',
        codeRecognized: 'Codice riconosciuto',
        moveAllEntriesFromCurrentLocation:
            'Sposta tutte le voci da questa posizione',
        newAwaitingValue: 'Nuovo valore in attesa di approvazione',
        newValuesArePendingConfirmation:
            'Le modifiche sono in attesa di approvazione',
        changeRequests: 'Cambia richieste',
        currentValues: 'Valori attuali',
        requestedValues: 'Valori da cambiare',
        removeRequestIsWaitingForApprove:
            'La cancellazione è in attesa di approvazione',
        imageRemoveRequestLabel: 'Eliminazione di una foto',
        areYouSureAboutCancelChangeRequest:
            'Sei sicuro di voler annullare la richiesta di modifica?',
        document: 'Documento',
        rename: 'Rinominare',
        openInEditor: "Apri nell'editor",
        unsavedChangesMayBeLost:
            'Le modifiche non salvate potrebbero andare perse',
        location_name_regex: 'Regola del nome della posizione',
        employeesWorkingCount:
            'Numero di dipendenti che lavorano su questo problema',
        always: 'Sempre',
        indexes: 'Indici',
        indexesEntriesTypes: 'Tipi di voci',
        indexEntry: "Voce dell'indice",
        index: 'Indice',
        pickIndex: 'Seleziona un indice',
        report: 'Rapporto',
        reportGenerationInProgress: 'Il rapporto è in fase di generazione',
        production_monitor_equipment_state_change:
            'Modificare lo stato della macchina dal monitor di produzione',
        part_entries_auto_barcode_generation:
            'Generazione automatica di codici a barre per le voci dei pezzi',
        new_issue_equipment_kind:
            'Tipo di attrezzatura nella nuova applicazione',
        manageVisibleColumns: 'Regola la visibilità della colonna',
        columnName: 'Nome della colonna',
        visible: 'Visible',
        partStorageRootWarningMessage:
            "Questa ubicazione verrà impostata come ubicazione principale del magazzino delle parti, il magazzino e la finestra di selezione dell'ubicazione del magazzino consentiranno solo di selezionare le voci situate in questa ubicazione",
        entriesLocation: 'posizione delle voci',
        cloneIssue: 'Clone',
        machinesMap: 'Mappa della macchina',
        doYouWantToAddNewMarker: 'Vuoi aggiungere un nuovo tag qui?',
        areYouSureAboutRemoveMarker:
            'Sei sicuro di voler rimuovere questo tag?',
        plants: 'Impianti di fabbrica',
        plant: 'Fabbrica',
        buildings: 'Edifici',
        building: 'Edificio',
        floors: 'Piani',
        floor: 'Pavimento',
        map: 'Carta geografica',
        areYouSureAboutMoveMarker:
            'Sei sicuro di voler spostare questo indicatore?',
        marker: 'Marcatore',
        addNewMarkerTooltipMessage:
            'Per aggiungere un nuovo indicatore, fai clic con il pulsante destro del mouse sulla mappa.',
        takenTools: 'Strumenti scaricati',
        askPermittedUserToConfirmToolExchange:
            "Chiedi alla persona autorizzata di confermare l'emissione/restituzione dello strumento scansionando la carta o inserendo il codice.",
        warnDays: 'Avviso prima della scadenza (giorni)',
        licenseType: 'Tipo di licenza',
        licenseGroup: 'Gruppo di licenze',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Richiedere conferma / rifiuto alla restituzione degli strumenti scaricati',
        attachments: 'Allegati',
        attachment: 'Allegato',
        searchInCurrentLocation: 'Cerca nella tua posizione attuale',
        icon: 'Icona',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'altro',
        tags: 'Carte / Tag',
        tag: 'Carta / Etichetta',
        userPinCode: "PIN dell'utente della carta",
        pin_code_field_type: 'Tipo di codice PIN',
        alphanumeric: 'Alfanumerico',
        numeric: 'Numerico',
        showCodeOwnerNameDuringParing:
            "Mostra il nome del proprietario del codice durante l'associazione con la carta/tag",
        showUsernameInCart: 'Mostra il nome utente nel carrello',
        flag: 'Bandiera',
        flags: 'Bandiere',
        manageFlags: 'Gestisci i flag',
        skills: 'Competenze',
        skill: 'Abilità',
        skillRank: 'Valutazione',
        selectToolsByType: 'Seleziona gli strumenti per tipo',
        openToolsPickerOnCartInit:
            'Apri automaticamente la finestra di selezione degli strumenti quando vai al carrello.',
        toolsTypes: 'Tipi di strumenti',
        workOrderTemplates: 'Modelli di ordini di lavoro',
        workOrderTemplate: 'Modello di ordine di lavoro',
        workOrders: 'Ordini di lavoro',
        workOrder: 'Ordine di lavoro',
        employee: 'Dipendente',
        workOrderCreatedBy: 'Commissionato da',
        print: 'Stampa',
        issueCreated: 'È stato creato un ticket',
        newIssue: 'Nuovo rapporto',
        sampleButtonPlaceholder: 'Pulsante campione',
        preferences: 'Preferenze',
        buttonsSize: 'Dimensione del pulsante',
        defaultValue: 'Valore di default',
        warning: 'Avvertimento',
        allowedIssuesCategories: 'Categorie di problemi consentiti',
        hideAbilityToAssignEmployeesToIssue:
            'Nascondere la possibilità di assegnare i dipendenti a un problema',
        issuesWithRelatedCategories: 'Includi sottocategorie',
        issuesLimit: 'Limite dei problemi',
        issuesLimits: 'Problemi - limiti',
        closeLocker: "Chiudere l'armadietto",
        closeLockerMessage: "Per continuare, chiudere l'armadietto",
        closedTooFast: 'Hai chiuso troppo in fretta?',
        doYouWantToReopenLocker: "Vuoi riaprire l'armadietto?",
        reopen: 'Riaprire',
        quit: 'Fine',
        hiddenFields: 'Campi nascosti',
        defaultValues: 'Valori standard',
        paddingBottom: 'Spazio vuoto in basso',
        allVisibleFieldsRequired:
            'Richiedi che tutti i campi visibili siano completati',
        emailConfirmation: "Conferma dell'indirizzo e-mail",
        user_active_after_email_confirm:
            'Account utente attivato automaticamente dopo aver confermato il tuo indirizzo email',
        phone_change_requires_confirmation_code:
            'La modifica del numero di telefono richiede la conferma con un codice',
        toolsLocation: 'Posizione dello strumento',
        manageFilters: 'Gestisci i filtri',
        erase: 'cancellare',
        can_pick_undescribed_equipment_state:
            'Possibilità di scegliere uno stato indescrivibile',
        helpdesk: 'Helpdesk',
        measureTypes: 'Tipi di misurazioni',
        measureType: 'Tipo di misurazione',
        measurable: 'Indicatore misurabile',
        measurables: 'Indicatori misurabili',
        measurements: 'Misurazione',
        measurement: 'Misurazione',
        measuredAt: 'Data di misurazione',
        employeeNumber: 'Impiegato numero',
        lastLocation: 'Ultima posizione',
        readonly: 'Lecture seulement',
        equipment: 'Attrezzatura',
        conditions: 'Condizioni',
        permission: 'Autorizzazione',
        formula: 'Formula',
        notification: 'Notifica',
        transition: 'Transizione',
        fillValuesToChangeState: 'Completa i valori per modificare lo stato.',
        loginTo: 'Accedere',
        appName: 'Signalo CMMS',
        manageState: 'Gestisci lo stato',
        webMessage: 'Messaggio web',
        terminalId: 'Identificativo terminale',
        operatorId: 'Identificativo operatore',
        newConversation: 'Nuovo thread',
        application: 'App',
        phones: 'Numeri di telefono',
        message: 'Messaggio',
        channels: 'Canali',
        url: 'URL',
        kind: 'Tipo',
        forkfleetConfigId: 'Configurazione Forkfleet',
        create: 'Creare',
        terminate: 'Terminare',
        recreateIssue: 'Ricreare il biglietto',
        ordinal: 'Valore ordinale',
        parameterName: 'Nome del parametro',
        backgroundColor: 'Colore di sfondo',
        columns: 'Numero di colonne',
        colspan: 'Larghezza (colonne)',
        fill: 'Completare',
        duplicate: 'Duplicare',
        loginAsThisUser: 'Accedi come questo utente',
        partLot: 'Serie',
        minBrowserVersion: 'È richiesta la versione minima del browser',
        currentVersion: 'Versione attuale',
        equipment_planned_completed_percent_target:
            "Obiettivo percentuale per l'attuazione delle ispezioni pianificate",
        autoTranslate: 'Traduzione automatica',
        auto_translation: 'Traduzione automatica',
        awaitingAutoTranslation: 'In attesa della traduzione automatica',
        signaturePinTagConfirmationText1:
            'Firmare con il @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'o scansiona la tua carta.',
        signedWithPinCode: 'Firmato con @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Firmato con card/tag',
        trusted_device_code_login_users_limit:
            'Accesso rapido: numero di utenti visualizzati',
        display_fields_issue_created_at:
            'Visualizzare i campi - Creazione di un rapporto',
        docs_sidebar_hidden_by_default:
            'Documenti - nascondere la barra laterale per default',
        issue: 'Segnalazione',
        control: 'Controllo',
        compatibility: 'Compatibilità',
        replacement: 'Sostituzione',
        backCompatibility: 'Compatibilità bidirezionale',
    },
    placeholders: {
        part: 'Seleziona parte...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Numero di telefono...',
        password: 'Password...',
        password_confirmation: 'Conferma password...',
        email: 'E-mail...',
    },
    auth: {
        notYourAccountQuestion: 'Non è il tuo account?',
    },
    signup: {
        registered: 'Successo!',
        emailConfirmed: "L'e-mail è stata confermata.",
        registered_info: 'Chiedi al tuo supervisore di attivare il tuo account',
        confirmEmailAddress:
            'Il tuo account è stato creato, fai clic sul collegamento nell`e-mail per confermare il tuo indirizzo.',
        tokenNotFoundError:
            "L'e-mail è già stata confermata o il collegamento di conferma non è valido.",
    },
    paramTypes: {
        text: 'Testo',
        note: 'Nota',
        integer: 'Intero',
        decimal: 'Decimale',
        date: 'Data',
        time: 'Ora',
        datetime: 'Data e ora',
        color: 'Colore',
        icon: 'Icona',
        boolean: 'No / Sì',
        signature: 'Firma',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Nome',
        path: 'Percorso del file',
        category: 'Categoria',
        equipment: 'Attrezzatura',
        criticality: 'Criticità',
        status: 'Stato',
        created: 'Creato',
        createdBy: 'Creato da',
        fp: 'FP',
        type: 'Tipo',
        designation: 'Denominazione',
        symbol: 'Simbolo',
        serialNumber: 'Numero di serie',
        registryNumber: 'Numero di registro',
        udtNumber: 'Numero UDT',
        manufacturedYear: 'Anno di produzione',
        actions: 'Azioni',
        title: 'Titolo',
        data: 'Data',
        archived: 'Archiviato',
        manufacturerSymbol: 'Simbolo del produttore',
        min: 'Min',
        opt: 'Ott',
        quantity: 'Quantità',
        priority: 'Priorità',
        price: 'Prezzo',
        kind: 'Tipo',
        description: 'Descrizione',
        default: 'Predefinito',
        warning: 'Avvertimento',
        problem: 'Problema',
        fixing: 'Riparazione',
        changeOrder: 'Ordine di modifica',
        required: 'Necessario',
        icon: 'Icona',
        color: 'Colore',
        subCategories: 'Sottocategorie',
        barCode: 'Codice a barre',
        subLocations: 'Sottolocalizzazioni',
        categories: 'Categorie',
        image: 'Immagine',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'E-mail',
        phone: 'Numero di telefono',
        function: 'Funzione',
        department: 'Dipartimento',
        accountStatus: 'Stato account',
        shift: 'Turno',
        licenseNumber: 'Numero di licenza',
        issuedDate: 'Data di emissione',
        expiresDate: 'Data di scadenza',
        entries: 'Voci',
        entryNumber: 'Numero di ingresso',
        buyPrice: 'Prezzo di acquisto',
        currentLocationQuantity: 'Quantità nella posizione corrente',
        group: 'Gruppo',
        string: 'Testo',
        integer: 'Intero',
        toolsGroup: 'Gruppo di strumenti',
        manufacturer: 'Produttore',
        shortName: 'Nome breve',
        locationName: 'Nome posizione',
        subLocationsQuantity: 'Quantità sotto-località',
        isWorkingOnIssue: 'Lavorando su un problema',
        openIssues: 'Problemi aperti',
        notificationDate: 'Data di notifica',
        titleAndDescription: 'Titolo e descrizione',
        read: 'Letto',
        created_at: 'Creato',
        received_at: 'Ricevuto',
        started_at: 'Preso',
        arrived_at: 'Arrivato',
        finished_at: 'Finito',
        country: 'Paese',
        city: 'Città',
        progress: 'Progresso',
    },
    searchConfig: {
        id: 'Id',
        name: 'Nome...',
        shortName: 'Nome breve...',
        country: 'Paese...',
        email: 'Email...',
        group: 'Gruppo...',
        planned: 'Programmato',
        category: 'Categoria...',
        object: 'Oggetto...',
        criticality: 'Criticità',
        fp: 'FP',
        type: 'Tipo...',
        designation: 'Denominazione...',
        symbol: 'Simbolo...',
        serialNumber: 'Numero di serie...',
        registryNumber: 'Numero di registro...',
        udtNumber: 'Numero UDT...',
        manufacturedYear: 'Anno di fabbricazione...',
        manufacturerSymbol: 'Simbolo del produttore...',
        priority: 'Priorità...',
        quantity: 'Quantità...',
        buyPrice: 'Prezzo di acquisto...',
        kind: 'Tipo...',
        toolsGroup: 'Gruppo di strumenti...',
        function: 'Funzione...',
        department: 'Dipartimento...',
        status: 'Stato...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Telefono...',
        barCode: 'Codice a barre',
        color: 'Colore...',
        icon: 'Icona...',
        machine: 'Macchina...',
        tool: 'Strumento...',
        urgentAndOutdated: 'Urgente e scaduto',
        urgent: 'Urgente',
        expired: 'Scaduto',
        manufacturer: 'Produttore',
    },
    errors: {
        error: 'Si è verificato un errore',
        wrongEmail: 'Email non valida',
        wrongPasswordLength: 'La password deve avere almeno 8 caratteri.',
        wrongCodeLength:
            'Il codice deve avere almeno 5 caratteri di lunghezza.',
        passwordsNotMatch: 'Le password non corrispondono',
        codesNotMatch: 'I codici non corrispondono',
        codeAlreadyInUse: 'Codice già utilizzato',
        expiresDateLowerThanIssued:
            'La data di scadenza non può essere inferiore alla data di emissione.',
        cannotMoveToTheSameLocation:
            'Impossibile spostarsi nella stessa posizione.',
        locationRequired: 'La posizione è obbligatoria.',
        putQuantity: 'Inserisci la quantità da separare.',
        valueGreaterThanQuantity: 'Il valore è maggiore della quantità totale.',
        wholeCannotBeDistinguished: "L'intero non può essere distinto.",
        yearMustBeGreaterThan: "L'anno deve essere maggiore di ",
        passwordConfirmationNotMatch: 'Le password non corrispondono',
        mustBeInteger: 'Il valore deve essere un numero intero',
        valueTooLong: 'Valore troppo lungo',
        wrongPhoneNumber: 'Numero di telefono non corretto',
        phoneNumberAlreadyTaken: 'Numero di telefono già utilizzato',
        emailAlreadyTaken: 'Email già utilizzata',
        notFound: 'Non trovato',
        sessionExpired: 'Sessione scaduta',
        tenantNotFound:
            "La configurazione indicata non esiste. Controllare l'indirizzo del sito e riprovare.",
        selectEquipmentTypeToConfigureParameters:
            'Seleziona il tipo di attrezzatura per configurare i parametri.',
        noParametersToConfigure:
            'Il tipo di attrezzatura selezionato non ha parametri da configurare.',
        terminalAlreadyRegistered: 'Terminale già registrato.',
        invalidPin: 'PIN non valido',
        eventCollision:
            "Il tempo dell'evento che si vuole aggiungere si sovrappone al tempo di un altro evento.",
        mustStartWithSlash: 'Deve iniziare con /',
        mustBeBetween: 'Il valore deve essere compreso tra:',
        minLength: 'Lunghezza minima: ',
        maxLength: 'Lunghezza massima: ',
        invalidInputForCodeType:
            'Input non valido per il tipo di codice selezionato',
        invalidCodeOrNoPermission:
            'Il codice non è valido o non hai sufficienti autorizzazioni per eseguire questa azione.',
        endDateLowerThanStart:
            'La data di fine non può essere inferiore alla data di inizio',
        iconAlreadyTaken: "L'icona è già stata presa",
        notEnoughQuantityInStorage: 'Quantità insufficiente in magazzino.',
        valueTooLow: 'Valore troppo basso',
        valueTooHigh: 'Valore troppo alto',
        maxAvailableQuantity: 'Numero massimo',
        someFilesRejectedDueToSize:
            'Alcuni file sono stati rifiutati a causa delle dimensioni. Dimensione massima del singolo file:',
        cameraDeviceNotFound: 'Dispositivo fotocamera non trovato',
        cameraPermissionDenied:
            "L'accesso alla telecamera del dispositivo è stato bloccato nelle impostazioni del sito; ripristinare le impostazioni del sito e consentire l'utilizzo della telecamera.",
        passwordResetLinkExpired:
            'Il collegamento per reimpostare la password è scaduto',
        noInternetConnection: 'Nessuna connessione internet',
        minimum: 'Minimo',
        mustBeGreaterThan: 'Deve essere maggiore di',
        noEventTypesDefined: 'Nessun tipo di evento definito',
        regexPatternDelimiterError:
            'Il separatore deve essere omesso con il carattere \\ n, ad esempio: \\/',
        emailNotMatchPatternDefiniedInTenant:
            "L'email non corrisponde al modello definito nel tenant",
        partMustHaveEntriesToCorrectQuantity:
            'La parte deve avere voci per correggere la quantità.',
        fileTooBigToOpenWillBeDownloaded:
            'Il file è troppo grande per essere aperto, il file verrà scaricato sul tuo dispositivo.',
        entriesNotSavedDueToCollision:
            "Le voci non sono state aggiunte. Gli eventi esistono già all'ora selezionata.",
        someEntriesWereRejected:
            'Alcune voci non sono state aggiunte perché in conflitto con altri eventi.',
        toolAlreadyInCart: 'Questo strumento è già nel tuo carrello',
        toolAlreadyTaken: 'Questo strumento è già stato rilasciato',
        toolIsNotTaken: 'Questo strumento non è stato rilasciato',
        documentNotEditable: 'Questo documento non può essere modificato',
        notPermissionsToEditDocument:
            "Non hai l'autorizzazione per modificare questo documento",
        cannotLoadDocumentNoPath:
            'Impossibile caricare il documento: indirizzo non valido',
        locationNameNotMatchPatternDefiniedInTenant:
            'Il nome non corrisponde alla regola definita nelle impostazioni',
        noFloorLayoutProvided: 'Il pavimento non ha una mappa definita',
        maximum: 'Valore massimo',
        allLanguagesRequired: 'Completa il valore in tutte le lingue',
        noItemsAvailable: 'Nessun articolo disponibile',
        noFlagsConfigured: 'Nessun flag definito',
        noSkillsDefined: 'Nessuna abilità definita',
        someoneIsWorkingOnIssue:
            'Non tutti i dipendenti hanno completato il lavoro su questo rapporto. Sei sicuro di voler farla finita?',
        fillAllRequiredParameters: 'Completa tutti i parametri richiesti.',
        issueLimitError:
            'È stato raggiunto il limite di problemi nella categoria selezionata per: ',
        issueLimitError2: 'e funzione: ',
        duplicateError: 'Questo valore esiste già',
        versionErrorMessage:
            'Le tue modifiche recenti non sono state salvate perché qualcun altro ha apportato modifiche contemporaneamente. Aggiorna la pagina e riprova.',
        firstLoginTrustedDeviceError:
            "Il primo accesso su un nuovo dispositivo richiede l'inserimento del tuo indirizzo email e della password.",
        tagNotFound: 'Carta/tag non riconosciuto',
        noChecklistsAssignedToControl:
            'Al controllo selezionato non è assegnata una lista di controllo',
        lockerNotConnected: 'La serratura non è collegata',
        lockerNotAvailable: 'La serratura non è disponibile',
        noChecklistItemsError: 'La checklist non è configurata',
    },
    navDrawer: {
        dashboard: 'Bacheca',
        issues: 'Problemi',
        timetable: 'Orario',
        machines: 'Macchine',
        tools: 'Strumenti',
        parts: 'Parti',
        storage: 'Magazzino',
        staff: 'Personale',
        configuration: 'Configurazione',
        notes: 'Note',
        notifications: 'Notifiche',
        profile: 'Profilo',
        supervision: 'Supervisione',
    },
    barcodeScanner: {
        barCode: 'Codice a barre',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Categoria...',
        selectCategory: 'Seleziona categoria',
        noSubcategories: 'Nessuna sottocategoria',
    },
    companies: {
        addCompany: 'Aggiungi azienda',
        editCompany: 'Modifica azienda',
        fullName: 'Nome completo',
        shortName: 'Nome breve',
        group: 'Gruppo',
        country: 'Paese',
        city: 'Città',
        street: 'Strada',
        postCode: 'Codice postale',
        phone: 'Telefono',
        email: 'E-mail',
        website: 'Sito web',
        NIP: 'NIP',
        REGON: 'Registro nazionale delle imprese',
        active: 'Attivo',
        nameRequired: 'Il nome è obbligatorio',
        shortNameRequired: 'Il nome è obbligatorio',
    },
    issues: {
        tookAt: 'Preso alle',
        changeHistory: 'Cronologia modifiche',
        load: 'Carica',
        date: 'Data',
        createdBy: 'Creato da',
        action: 'Azione',
        data: 'Dati',
        created: 'Creato',
        updated: 'Aggiornato',
        deleted: 'Eliminato',
        restored: 'Ripristinato',
        issues: 'Problemi',
        issue: 'Problema',
        by: 'da',
        name: 'Nome',
        applicantsDescription: 'Descrizione del richiedente',
        accidentDescription: "Descrizione dell'accaduto",
        jobDescription: 'Descrizione del lavoro',
        jobSummary: 'Riepilogo del lavoro',
        category: 'Categoria',
        status: 'Stato',
        noFlow: '[Nessun flusso]',
        equipment: 'Attrezzatura',
        criticality: 'Criticità',
        hour: 'Ora',
        formalConfirmation: 'Conferma formale',
        formalConfirmationShortcut: 'CF',
        formalConfirmationRequired: 'CF richiesta',
        parameter: 'Parametro',
        value: 'Valore',
        addIssue: 'Aggiungi problema',
        expectedCompletionDate: 'Data prevista di completamento',
        issueDescription: 'Descrizione del problema',
        partsUsage: 'Utilizzo di parti',
        assignedEmployees: 'Dipendenti assegnati',
        requiredHelp: 'Aiuto richiesto',
        returnParts: 'Restituire parte',
        confirmUnassignEmployeeWhoTakenIssue:
            'Questo dipendente ha preso il problema selezionato. Vuoi rimuoverlo?',
        responsibleUser: 'Utente responsabile',
        responsibleRules: 'Utenti responsabili - regole',
    },
    machines: {
        machines: 'Macchine',
        xIssuesNotPlanned: ' (non pianificate)',
        noIssues: 'Nessun problema',
    },
    maintenance: {
        maintenance: 'Manutenzione',
    },
    notes: {
        notes: 'Note',
        note: 'Nota',
        title: 'Titolo',
        archived: 'Archiviate',
    },
    parts: {
        parts: 'Pezzi di ricambio',
        warehouseOutgoings: 'Uscite dall' + "'" + ' magazzino',
        fittingEquipmentTypes: 'Tipi di attrezzature compatibili',
        goToEquipmentType: 'Vai al tipo di attrezzatura',
        selectPart: 'Seleziona parte',
        usageReason: 'Motivo',
        usageOtherReason: 'Altro',
        replacements: 'Sostituzioni',
        partEntry: 'Inserimento pezzo',
        goToPart: 'Vai alla parte',
        fittingMachines: 'Macchine abbinate',
    },
    costCenter: {
        costCenter: 'Centro di costo',
    },
    equipmentTypes: {
        equipment: 'Attrezzatura',
        newEquipmentType: 'Nuovo tipo di attrezzatura',
        fittingParts: 'Pezzi di ricambio compatibili',
        goToParts: 'Vai ai pezzi',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Definizioni di macchine e attrezzi',
    },
    flows: {
        flow: 'Flusso',
        states: 'Stati',
        transitions: 'Transizioni',
        state: 'Stato',
        default: 'Predefinito',
        warning: 'Avviso',
        problem: 'Problema',
        fixing: 'Risoluzione',
        finished: 'Finito',
    },
    parameters: {
        categoryParameter: 'Parametro di categoria',
        equipmentTypeParameter: 'Parametro del tipo di attrezzatura',
    },
    staff: {
        staff: 'Staff',
        editUserAccess: 'Modifica accesso utente',
        permissionsUpdated: 'Permessi aggiornati',
        passwordUpdated: 'Password aggiornata',
        codeUpdated: 'Codice aggiornato',
        changePasswordAndCode: 'Cambia password e codice',
        goToLicenses: 'Vai alle licenze',
        editAccess: 'Modifica accesso',
        editUser: 'Modifica utente',
        addUser: 'Aggiungi un nuovo utente',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: "Stato dell'account",
        phoneNumber: 'Numero di telefono',
        department: 'Reparto',
        passwordChange: 'Cambio password',
        codeChange: 'Modifica del codice',
        newPassword: 'Nuova password',
        confirmNewPassword: 'Conferma nuova password',
        changePassword: 'Cambia password',
        newCode: 'Nuovo codice',
        confirmNewCode: 'Conferma il nuovo codice',
        changeCode: 'Cambia codice',
        addEntry: 'Aggiungi voce',
        editEntry: 'Modifica voce',
        editLicense: 'Modifica licenza',
        addLicense: 'Aggiungi licenza',
        licenseNumber: 'Numero di licenza',
        prefferedLocale: 'Locale preferito',
        oldPassword: 'Vecchia password',
        newPasswordConfirmation: 'Conferma la nuova password',
        reading: 'Visualizzazione',
        creating: 'Creazione',
        updating: 'Aggiornamento',
        deleting: 'Cancellazione',
        importScheduleFile: 'Importa una pianificazione da un file',
        importSchedule: {
            errors: {
                user_not_found: 'Utente non trovato [{user}]',
                user_found_many: '{count} utenti trovati [{user}]',
                event_collision: 'Collisione di eventi',
                hour_cell_parse: 'Errore di analisi della cella',
            },
        },
        oldCode: 'Vecchio codice',
        newCodeConfirmation: 'Conferma del nuovo codice',
        setAccessBasedOnProfile: "Concedi l'accesso in base al profilo",
        selectAccessMergeType: 'Scegli come combinare le autorizzazioni',
        noAccessesInProfileMessage:
            'Il profilo selezionato non dispone di autorizzazioni. Vuoi sovrascrivere comunque?',
    },
    breadCrumb: {
        configuration: 'Configuration',
        locations: 'Locations',
        home: 'Casa',
        machines: 'Macchine',
        tools: 'Strumenti',
        issues: 'Problemi',
        note: 'Note',
        maintenance: 'Manutenzione',
        parts: 'Parti',
        warehouse: 'Magazzino',
        dictionary: 'Dizionario',
        categories: 'Categorie',
        parameters: 'Parametri',
        costCenter: 'Centro di costo',
        flows: 'Flussi',
        states: 'Stati',
        transitions: 'Transizioni',
        shiftSchemas: 'Schemi dei turni',
        shifts: 'Turni',
        definitionsOfMachinesAndToolsTypes:
            'Definizioni dei tipi di macchine e strumenti',
        add: 'Aggiungi',
        edit: 'Modifica',
        staff: 'Staff',
        license: 'Licenze',
        entries: 'Voci',
        companiesDatabase: 'Database aziende',
        companyManagement: "Gestione dell'azienda",
        companyData: "Dati dell'azienda",
        supportedLanguages: 'Lingue supportate',
        en: 'Inglese',
        pl: 'Polacco',
        es: 'Spanish',
        it: 'Italiano',
        fr: 'Francese',
        ru: 'Russo',
        uk: 'Ucraino',
        pt: 'Portoghese',
        defaultLanguage: 'Lingua predefinita',
        notifications: 'Notifiche',
        notificationsManagement: 'Gestione delle notifiche',
        myProfile: 'Il mio profilo',
    },
    attributeTypes: {
        text: 'Testo',
        note: 'Nota',
        integer: 'Integer',
        decimal: 'Decimal',
        date: 'Data',
        time: 'Ora',
        dateTime: 'Data e ora',
        color: 'Colore',
        icon: 'Icona',
        boolean: 'Sì/No',
    },
    costCalculator: {
        costCalculator: 'Calcolatore dei costi',
        waitTime: 'Tempo di attesa',
        serviceTime: 'Tempo di servizio',
        suspendTime: 'Tempo di sospensione',
        totalTime: 'Tempo totale',
        estimatedCost: 'Costo stimato',
        calculate: 'Calcola',
        withoutParts: 'Senza parti',
        timeOfReportingIssue: 'Ora di segnalazione del problema',
        timeOfServiceStart: 'Ora di inizio del servizio',
        timeOfReportingEnd: 'Ora di fine servizio',
        days: 'Giorni',
        ore: 'Ore',
        minutes: 'Minuti',
        enterNewTime: 'Inserisci la nuova ora',
        fromIssueReportToServiceStart:
            "Tempo dal rapporto di emissione all'avvio del servizio",
        fromServiceStartToServiceEnd:
            "Tempo dall'inizio del servizio alla fine del servizio",
        workTime: 'Tempo di lavoro',
        includeAwaitingTime: 'Include il tempo di attesa',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'I miei problemi',
                assignedToMe: 'Assegnato a me',
                assignedToGroup: 'Assegnato al mio gruppo',
                tookByMe: 'Assegnato da me',
                takeIssueBtn: 'Prendi',
                arriveIssueBtn: 'Sono arrivato',
                finishIssueBtn: 'Finisci',
                history: 'Storia',
                myResponsible: 'Sono responsabile di',
            },
        },
    },
    synchronization: {
        enabled: 'Enabled',
        hasHeaders: 'Ha intestazioni',
        leaveFile: 'Lascia il file',
        host: 'Host',
        port: 'Porta',
        protocol: 'Protocollo',
        username: 'Nome utente',
        password: 'Password',
        root: 'Root',
        encoding: 'Codifica',
        separator: 'Separator',
        externalSystemId: 'ID sistema esterno',
        cronExpression: 'Espressione cron',
        appendFullStock: "Aggiungi l'intero stock",
        includeHeaders: 'Includi intestazioni',
        withTrashed: 'Con dati rimossi',
        filePattern: 'Modello di file',
    },
    processes: {
        created_at: 'Creato a',
        started_at: 'Avviato alle',
        updated_at: 'Aggiornato alle',
        finished_at: 'Finito alle',
        attempts: 'Tentativi',
        queue: 'Coda',
        job_id: 'ID lavoro',
        job_uuid: 'Job uuid',
        progress_max: 'Avanzamento massimo',
        progress_now: 'Avanzamento ora',
        outputMessage: 'Messaggio di uscita',
        status: {
            queued: 'queued',
            executing: 'executing',
            finished: 'finished',
            failed: 'failed',
            retrying: 'retrying',
            undefined: 'non definito',
        },
    },
    weekDays: {
        mo: 'Lunedì',
        tu: 'Martedì',
        we: 'Mercoledì',
        th: 'Giovedì',
        fr: 'Venerdì',
        sa: 'Sabato',
        su: 'Domenica',
    },
    reports: {
        reports: 'Rapporti',
        dateFrom: 'Data di inizio',
        dateTo: 'Data di fine',
        types: {
            operation_sheet: 'Foglio operativo',
            issue_summary: 'Riassunto della problematica',
            grouped_summary: 'Relazione di sintesi',
            storage_operations: 'Operazioni di magazzino',
            part_quantity_export: 'Quantità di parti',
        },
        reportFor: 'Segnala per',
        includeQuantityLeft0: 'Includere parti con quantità nulla',
    },
    logs: {
        issues: {
            escalation: 'Escalation ({minutes} min) - notifica inviata',
        },
        issueEmployee: {
            assignedAt: 'Dipendente assegnato:',
            receivedAt: 'Dipendente ha ricevuto:',
            tookAt: 'Dipendente ha assunto:',
            finishedAt: 'Dipendente ha completato:',
            deletedAt: 'Dipendente rimosso dalla segnalazione',
        },
    },
    units: {
        no: 'Pezzo',
        st: 'Impostato',
    },
    rrule: {
        frequency: 'Frequenza',
        dtstart: "Data d'inizio",
        tzid: 'Fuso orario',
        until: 'Fino a',
        count: 'Contare',
        interval: 'Intervallo',
        wkst: 'Giorno di inizio',
        byweekday: 'Nei giorni feriali',
        bymonth: 'Per mese',
        yearly: 'Annuale',
        monthly: 'Mensile',
        weekly: 'Settimanalmente',
        daily: 'Quotidiano',
        hourly: 'Ogni ora',
        minutely: 'Minuziosamente',
        secondly: 'In secondo luogo',
        infinitePeriodicityMessage:
            'La periodicità è infinita, a causa delle prestazioni, vengono visualizzate solo 500 righe',
    },
    months: {
        jan: 'Gennaio',
        feb: 'Febbraio',
        mar: 'Marzo',
        apr: 'Aprile',
        may: 'Maggio',
        jun: 'Giugno',
        jul: 'Luglio',
        aug: 'Agosto',
        sep: 'Settembre',
        oct: 'Ottobre',
        nov: 'Novembre',
        dec: 'Dicembre',
    },
    charts: {
        charts: 'Grafici',
        count: 'Numero di problemi',
        total: 'Tempo totale dei problemi (dal report alla fine)',
        serw: 'Tempo totale di riparazione (Ttotal - Twait)',
        mttr1: 'Tempo medio dalla relazione alla fine',
        mttr2: 'Tempo medio dalla ripresa alla fine',
        mtbf: 'Tempo di attività medio tra i problemi',
        mttf: 'Tempo medio al fallimento',
    },
    accessMergeValues: {
        sum: 'Somma',
        product: 'Prodotto',
        overwrite: 'Sovrascrivere',
    },
    tpm: {
        history: 'Storia',
        standardObstacle: 'Ostacolo standard',
        customObstacle: 'Ostacolo personalizzato',
        bhp: 'Sicurezza sul lavoro',
        returnToMainPage: 'Torna alla pagina principale',
        bhpMessage:
            'Se noti dei pericoli per la sicurezza, segnalali immediatamente al tuo superiore diretto e utilizza il modulo di segnalazione situato sotto la bacheca.',
        ok: 'OK',
        send: 'Invia',
        description: 'Descrizione',
        title: 'Titolo',
        realization: 'Realizzazione',
        answer: 'Risposta',
        pendingSurveys: 'Indagini in corso',
        surveys: 'Indagini',
        systemSurvey: 'Indagine di sistema',
        addPage: 'Aggiungi pagina',
        createSurvey: 'Crea indagine',
        addSection: 'Aggiungi sezione',
        addQuestion: 'Aggiungi domanda',
        questionContent: 'Contenuto della domanda',
        answerOption: 'Opzione di risposta',
        addQuestionAnswer: 'Aggiungi opzione di risposta',
        surveyName: "Nome dell'indagine",
        sectionName: 'Nome della sezione',
        noSurveyAnswers: 'Nessuna risposta',
        removeSection: 'Rimuovi sezione',
        published: 'Pubblicato',
        unpublished: 'Non pubblicato',
        pendingPublication: 'Modifiche in attesa di pubblicazione',
        removeQuestion: 'Rimuovi domanda',
        removeAnswer: 'Rimuovi opzione di risposta',
        publish: 'Pubblica',
        unpublish: 'Annulla pubblicazione',
        previewResults: 'Anteprima dei risultati',
        supervisior: 'Responsabile',
        surveyResults: "Risultati dell'indagine",
        surveysEvents: 'Configurazione eventi - indagini',
        operatedBy: 'Gestito da',
        confirmReadInformations: 'Ho letto le informazioni',
        noticeContent: "Contenuto dell'avviso",
        notice: 'Avviso',
        surveyEventName: "Nome dell'evento",
        survey: 'Indagine',
        newIssue: 'Nuova segnalazione',
        surveyEventConfigurationAlreadyExists:
            'Questa configurazione esiste già',
        lastComment: 'Ultimo commento della persona responsabile',
        surveyNotConfigured: 'Indagine non configurata',
        fillSurvey: "Compila l'indagine",
        singleSurveyEntries: 'singoli risultati',
        groupedSurveyEntries: 'Risultati raggruppati',
        publicationId: 'ID pubblicazione',
        publicationDate: 'Data di pubblicazione',
        versionId: 'ID versione',
        answersCount: 'Numero di risposte',
        answers: 'Risposte',
        withoutSupervisor: 'Nessun supervisore',
        defaultSupervisor: 'Supervisore predefinito',
        flowStateFlags: 'Flag di stato',
        qrActionsSettings: "Impostazioni dell'azione del codice QR",
        loginRequired: 'Richiede il login',
        questionContext: 'Il contesto della domanda',
        currentSurveyVersionPreview:
            'Anteprima della versione attuale del sondaggio',
        surveyDescription: 'Descrizione del sondaggio',
        sectionDescription: 'Descrizione della sezione',
        instructions: 'Istruzioni',
        instruction: 'Istruzioni',
        instructionRevisions: 'Revisioni',
        instructionRevision: 'Revisione',
        checklists: 'Liste di controllo',
        checklist: 'Lista di controllo',
        checklistItem: 'Voce dell`elenco',
        manageChecklistFields: 'Gestisci gli elementi dell`elenco',
        checklistItemDisplayOptions: 'Articoli visualizzati',
        revisionAutoRejectedInfo:
            '[Sistema] Rifiutato: creata una nuova revisione',
    },
    checklists: {
        itemBasic: 'Elemento fondamentale',
        itemSeparator: 'Separatore',
        itemSection: 'Sezione',
        publish: 'Pubblicare',
        previewCurrentVersion: 'Anteprima della versione attuale',
    },
};
